const ROOT =
  (process.env.REACT_APP_MARKETPLACE_ROOT_URL || '').replace(/\/$/, '') || 'https://vivianlab.com';

const build = path => `${ROOT}${path}`;

export const SYMPTOM_BLOG_LINKS = {
  lowEnergy: {
    englishUrl: build('/blog/low-energy-and-fatigue-in-menopause-how-to-regain-your-vitality'),
    greekUrl: build(
      '/el/blog/xamili-energeia-kai-koyrasi-stin-emminopaysi-pos-na-k-sanavreis-ti-zontania-soy'
    ),
  },
  insomnia: {
    englishUrl: build('/en/blog/overcoming-sleep-disturbances-in-menopause'),
    greekUrl: build('/blog/ksepernontas-tis-diataraxes-ipnou-stin-emminopafsi'),
  },
  brainFog: {
    englishUrl: build('/en/blog/brain-fog-in-menopause-what-it-is-and-how-to-treat-it'),
    greekUrl: build('/blog/omixli-egkefaloy-stin-emminopaysi-ti-einai-kai-pos-antimetopizetai'),
  },
  moodSwings: {
    englishUrl: build(
      '/blog/mood-swings-and-depression-in-menopause-navigating-the-emotional-labyrinth'
    ),
    greekUrl: build(
      '/el/blog/allages-diathesis-kai-katathlipsi-stin-emminopaysi-katanoontas-ton-synaisthimatiko-lavyrintho'
    ),
  },
  headaches: {
    englishUrl: build(
      '/blog/headaches-and-migraines-in-menopause-why-they-appear-and-how-to-find-relief'
    ),
    greekUrl: build(
      '/el/blog/ponokefaloi-kai-imikranies-stin-emminopaysi-giati-emfanizontai-kai-pos-na-anakoyfisteis'
    ),
  },
  skinDryness: {
    englishUrl: build('/blog/dry-skin-in-menopause-why-its-appearance-changes-and-how-to-protect-it'),
    greekUrl: build(
      '/el/blog/k-sirotita-dermatos-stin-emminopaysi-giati-allazei-i-opsi-toy-kai-pos-na-tin-prostateyseis'
    ),
  },
  jointPain: {
    englishUrl: build('/en/blog/get-relief-from-frozen-shoulder-and-move-freely-again'),
    greekUrl: build('/blog/anakoufisou-apo-ton-pagomeno-omo-kai-na-kinisou-xana-elefthera'),
  },
  hotFlashes: {
    englishUrl: build('/en/blog/what-happens-to-hot-flashes-in-menopause'),
    greekUrl: build('/blog/ti-symvainei-me-tis-exapsis-stin-emminopafsi'),
  },
  anxiety: {
    englishUrl: build('/en/blog/ways-to-effectively-manage-stress-during-menopause'),
    greekUrl: build('/blog/tropoi-apotelesmatikis-diaxeirisis-tou-agchous-stin-emminopafsi'),
  },
  bloating: {
    englishUrl: build('/blog/bloating-and-water-retention-in-menopause-causes-and-relief'),
    greekUrl: build(
      '/el/blog/foyskoma-kai-katakratisi-ygron-stin-emminopaysi-poy-ofeilontai-kai-pos-na-anakoyfisteis'
    ),
  },
  lowLibido: {
    englishUrl: build(
      '/en/blog/decreased-libido-in-menopause-causes-effects-and-practical-solutions'
    ),
    greekUrl: build(
      '/blog/meiomeni-libido-stin-emminopafsi-aities-epiptoseis-kai-praktikes-lyseis'
    ),
  },
  weightGain: {
    englishUrl: build('/en/blog/weight-gain-during-menopause-how-to-deal-with-the-changes'),
    greekUrl: build('/blog/afxisi-varous-stin-emminopafsi-pos-na-antimetopisete-tis-allages'),
  },
  uterine: {
    englishUrl: build('/blog/uterine-prolapse-and-incontinence-strengthening-the-pelvic-floor'),
    greekUrl: build(
      '/el/blog/kataptosi-mitras-kai-akrateia-i-endynamosi-toy-pyelikoy-edafoys-stin-emminopaysi'
    ),
  },
  irregularPeriod: {
    englishUrl: build('/blog/irregular-periods-in-perimenopause-what-is-normal-and-what-is-not'),
    greekUrl: build(
      '/el/blog/akanonisti-periodos-stin-periemminopaysi-ti-einai-fysiologiko-kai-ti-oxi'
    ),
  },
  vaginalDryness: {
    englishUrl: build('/en/blog/vaginal-dryness-causes-symptoms-and-practical-solutions'),
    greekUrl: build('/blog/kolpiki-xirotiita-aities-symptwmata-kai-praktikes-lyseis'),
  },
};

export const fallbackBlogUrl = locale => build(locale === 'el' ? '/el/blog' : '/blog');
